// import React, { useRef, useEffect, useState } from "react";
// import CloseButton from "./CloseButton";
// import "./styles.scss";

// const Modal = ({
//   id,
//   title,
//   isActive,
//   onClose,
//   children,
//   width = "450px",
//   bodyStyles,
//   extrastyle,
//   maxHeight,
//   takeConfirmation,
//   paddingProp,
// }) => {
//   const modalContentRef = useRef(null);
//   const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

//   useEffect(() => {
//     const handleOverflowChange = () => {
//       const content = modalContentRef.current;

//       if (content.scrollHeight > content.clientHeight) {
//         // Content overflows, add the 'scrollable' class
//         content.classList.add("scrollable");
//       } else {
//         // Content does not overflow, remove the 'scrollable' class
//         content.classList.remove("scrollable");
//       }
//     };

//     // Listen for changes in overflow
//     const content = modalContentRef.current;
//     content.addEventListener("scroll", handleOverflowChange);

//     // Check overflow initially
//     handleOverflowChange();

//     // Cleanup listener
//     return () => {
//       content.removeEventListener("scroll", handleOverflowChange);
//     };
//   }, []);

//   const styles = {
//     ...extrastyle,
//     width: width,
//     maxHeight: maxHeight,
//   };
//   // const styleCase = {
//   //   fontSize: '20px',
//   //   fontWeight: 'bold',
//   // };
//   const bodyStyle = {
//     ...bodyStyles,
//     ...extrastyle,
//   };

//   const handleClose = () => {
//     if (takeConfirmation) {
//       setIsConfirmationModalOpen(true);
//     } else {
//       onClose();
//     }
//   };
//   return (
//     <>
//       <div id={id} className={`${paddingProp ? "modal-padding modal" : "modal"} ${isActive ? "active" : ""}`}>
//         <div
//           className="modal-content"
//           style={{ ...styles }}
//           ref={modalContentRef}
//         >
//           <div className="modal-header">
//             <p className="modal-heading mb-0">{title}</p>
//             <CloseButton onClose={handleClose} />
//           </div>
//           <div className="modal-body" style={{ ...bodyStyle }}>
//             {children}
//           </div>
//         </div>
//       </div>

//       {isConfirmationModalOpen && (
//         <div
//           id={id}
//           className={`modal ${isConfirmationModalOpen ? "active" : ""}`}
//         >
//           <div
//             className="modal-content"
//             style={{ width: "400px" }}
//             ref={modalContentRef}
//           >
//             <div className="modal-body p-0" style={{ ...bodyStyle }}>
//               <div className="p-4 pb-2">
//                 <p className="modal-heading mb-0">
//                   Your changes won’t be saved
//                 </p>

//                 <p className="mt-3">
//                   Click "Cancel" if you don’t want to lose the changes.
//                 </p>
//               </div>

//               <div
//                 className="px-4 py-3 d-flex gap-3 justify-content-end"
//                 style={{ borderTop: "1px solid #E5E7EB" }}
//               >
//                 <button className="btn btn-outline-dark" style={{ flex: 1 }} onClick={() => setIsConfirmationModalOpen(false)}>
//                   Cancel
//                 </button>
//                 <button className="btn btn-primary" style={{ flex: 1 }} onClick={onClose}>
//                   Confirm
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Modal;

// // import React, { useRef, useEffect, useState, useCallback } from "react";
// // import CloseButton from "./CloseButton";
// // import "./styles.scss";

// // const Modal = ({
// //   id,
// //   title,
// //   isActive,
// //   onClose,
// //   children,
// //   width = "450px",
// //   bodyStyles,
// //   extrastyle,
// //   maxHeight,
// //   takeConfirmation = false,
// // }) => {
// //   const modalContentRef = useRef(null);
// //   const [showConfirm, setShowConfirm] = useState(false);

// //   useEffect(() => {
// //     const handleOverflowChange = () => {
// //       if (!modalContentRef.current) return;

// //       if (modalContentRef.current.scrollHeight > modalContentRef.current.clientHeight) {
// //         modalContentRef.current.classList.add("scrollable");
// //       } else {
// //         modalContentRef.current.classList.remove("scrollable");
// //       }
// //     };

// //     handleOverflowChange();
// //   }, [isActive]);

// //   const handleBackdropClick = useCallback((e) => {
// //     if (!modalContentRef.current || modalContentRef.current.contains(e.target)) return;

// //     if (takeConfirmation && !showConfirm) {
// //       setShowConfirm(true);
// //     } else {
// //       onClose();
// //     }
// //   }, [takeConfirmation, showConfirm, onClose]);

// //   return (
// //     <>
// //       {isActive && (
// //         <div id={id} className="modal active" onClick={handleBackdropClick}>
// //           <div
// //             className="modal-content"
// //             style={{ width, maxHeight, ...extrastyle }}
// //             ref={modalContentRef}
// //             onClick={(e) => e.stopPropagation()} // Prevents modal close when clicking inside
// //           >
// //             <div className="modal-header">
// //               <p className="modal-heading mb-0">{title}</p>
// //               <CloseButton onClose={onClose} />
// //             </div>
// //             <div className="modal-body" style={{ ...bodyStyles, ...extrastyle }}>
// //               {children}
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {showConfirm && (
// //         <div className="modal-overlay">
// //           <div className="confirmation-modal">
// //             <p>Are you sure you want to close?</p>
// //             <button onClick={() => { setShowConfirm(false); onClose(); }}>Yes</button>
// //             <button onClick={() => setShowConfirm(false)}>No</button>
// //           </div>
// //         </div>
// //       )}
// //     </>
// //   );
// // };

// // export default Modal;

import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import CloseButton from "./CloseButton";
import "./styles.scss";

const Modal = ({
  id,
  title,
  isActive,
  onClose,
  children,
  width = "450px",
  bodyStyles,
  extrastyle,
  maxHeight,
  takeConfirmation,
  paddingProp,
}) => {
  const modalContentRef = useRef(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  useEffect(() => {
    const handleOverflowChange = () => {
      const content = modalContentRef.current;
      if (!content) return;

      if (content.scrollHeight > content.clientHeight) {
        content.classList.add("scrollable");
      } else {
        content.classList.remove("scrollable");
      }
    };

    const content = modalContentRef.current;
    if (content) {
      content.addEventListener("scroll", handleOverflowChange);
      handleOverflowChange(); // Check initially
    }

    return () => {
      if (content) {
        content.removeEventListener("scroll", handleOverflowChange);
      }
    };
  }, []);

  const styles = {
    ...extrastyle,
    width,
    maxHeight,
  };

  const bodyStyle = {
    ...bodyStyles,
    ...extrastyle,
  };

  const handleClose = () => {
    if (takeConfirmation) {
      setIsConfirmationModalOpen(true);
    } else {
      onClose();
    }
  };

  // Modal JSX
  const modalJSX = (
    <>
      <div id={id} className={`modal ${paddingProp ? "modal-padding" : ""} ${isActive ? "active" : ""}`}>
        <div className="modal-content" style={styles} ref={modalContentRef}>
          <div className="modal-header">
            <p className="modal-heading mb-0">{title}</p>
            <CloseButton onClose={handleClose} />
          </div>
          <div className="modal-body" style={bodyStyle}>
            {children}
          </div>
        </div>
      </div>

      {isConfirmationModalOpen && (
        <div className="modal active">
          <div className="modal-content" style={{ width: "400px" }} ref={modalContentRef}>
            <div className="modal-body p-0" style={bodyStyle}>
              <div className="p-4 pb-2">
                <p className="modal-heading mb-0">Your changes won’t be saved</p>
                <p className="mt-3">Click "Cancel" if you don’t want to lose the changes.</p>
              </div>

              <div className="px-4 py-3 d-flex gap-3 justify-content-end" style={{ borderTop: "1px solid #E5E7EB" }}>
                <button className="btn btn-outline-dark" style={{ flex: 1 }} onClick={() => setIsConfirmationModalOpen(false)}>
                  Cancel
                </button>
                <button className="btn btn-primary" style={{ flex: 1 }} onClick={onClose}>
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );

  // Use React Portal to render outside of side overlay
  return createPortal(modalJSX, document.getElementById("modal-root"));
};

export default Modal;

